export function normalizeInternalPath(value?: string | null, fallback = '/'): string {
  if (!value) return fallback;
  const rawValue = String(value);
  try {
    const decoded = decodeURIComponent(rawValue);
    if (!decoded.startsWith('/') || decoded.startsWith('//')) return fallback;
    if (rawValue.startsWith('/') && !rawValue.startsWith('//')) {
      return rawValue.replace(/%2f/gi, '/');
    }
    return decoded;
  } catch {
    return fallback;
  }
}

export function buildApprovePath(params: {
  solicitacaoId: string;
  handoff?: string;
  email?: string;
}): string {
  if (!params.solicitacaoId) throw new Error('solicitacaoId obrigatorio');
  const url = new URL(`/security/approve/${encodeURIComponent(params.solicitacaoId)}`, 'https://app.local');
  if (params.email) url.searchParams.set('email', params.email.trim().toLowerCase());
  if (params.handoff) url.searchParams.set('handoff', params.handoff);
  return `${url.pathname}${url.search}`;
}

export function buildInstallRedirectPath(params: {
  solicitacaoId: string;
  handoff?: string;
  email?: string;
}): string {
  const approvePath = buildApprovePath(params);
  const url = new URL('/install', 'https://app.local');
  url.searchParams.set('redirect', approvePath);
  if (params.email) url.searchParams.set('email', params.email.trim().toLowerCase());
  return `${url.pathname}${url.search}`;
}

export function buildLoginRedirectPath(params: {
  redirect?: string | null;
  email?: string;
}): string {
  const safeRedirect = normalizeInternalPath(params.redirect, '/');
  const url = new URL('/login', 'https://app.local');
  url.searchParams.set('redirect', safeRedirect);
  if (params.email) url.searchParams.set('email', params.email.trim().toLowerCase());
  return `${url.pathname}${url.search}`;
}
